import React from 'react'
import APPS from "../../assets/images/add.svg"
import Stack from "../../assets/images/database-security.svg"
import SmartHive from "../../assets/images/products/beehive.svg"
import Category from '../../components/Category/Category'


// OurTechnologyM component that displays a list of technology 
const OurTechnologyMain = () => {
  // Define the data for each technology item
  const data = [
    {
      image: APPS,
      title: "APPs",
      href: "/app",
    },
    {
      image: Stack,
      title: "Edge AI Stack",
      href: "/edge-ai-stack",
    },
    {
      image: SmartHive,
      title: "Eco-Bee",
      href: "/eco-bee",
    },
  ];

  return (
    <>
      {/* Render the Category component and pass the data as props */}
      <div>
        <Category data={data} />
      </div>
    </>
  );
}

export default OurTechnologyMain;


